import { useState, useEffect } from 'react';

const API_URL = 'https://api.tutormatchae.com/tutor-match-ae/v1/webhook/get-cms-details';

const Terms = () => {
  const [pageData, setPageData] = useState(null);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);

  const fetchTermsData = async () => {
    try {
      setLoading(true);
      setError(null);
      const response = await fetch(API_URL, {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
        },
        body: JSON.stringify({ tag_name: 'terms_conditions' }),
      });

      if (!response.ok) {
        throw new Error(`HTTP error! status: ${response.status}`);
      }
      const result = await response.json();
      console.log("Result", result);
      if (result) {
        setPageData(result);
      } else {
        throw new Error(result.message || 'Failed to fetch data');
      }
    } catch (err) {
      console.error('Error fetching terms data:', err);
      setError(err.message);
    } finally {
      setLoading(false);
    }
  };

  useEffect(() => {
    fetchTermsData();
  }, []);

  return (
    <div className="min-h-screen bg-white py-16 px-6">
      <div className="max-w-4xl mx-auto">
        {/* <h1 className="text-4xl font-bold text-slate-900 mb-8">Terms and Conditions</h1> */}
        <div className="prose prose-slate max-w-none overflow-hidden break-words" style={{ overflowWrap: 'break-word', wordBreak: 'break-word' }}>
          {loading ? (
            <div className="flex justify-center items-center py-12">
              <div className="animate-spin rounded-full h-10 w-10 border-t-2 border-b-2 border-primary"></div>
            </div>
          ) : error ? (
            <div className="text-center py-8">
              <p className="text-red-500 mb-4">Failed to load content.</p>
              <button
                onClick={fetchTermsData}
                className="px-4 py-2 bg-primary text-white rounded-lg hover:bg-opacity-90 transition-all"
              >
                Retry
              </button>
            </div>
          ) : pageData?.content ? (
            <div dangerouslySetInnerHTML={{ __html: pageData.content }} />
          ) : (
            <p className="text-slate-600">No content available.</p>
          )}
        </div>
      </div>
    </div>
  )
}

export default Terms;